export const ROUTE_VIEW_OFFER = 'ROUTE_VIEW_OFFER';
export const ROUTE_HOME = 'ROUTE_HOME';
export const ROUTE_BACK = 'ROUTE_BACK';
